import Hideable, { EL, IFACE } from './Hideable.js';
import Close from '../event/Close.js';
import Open from '../event/Open.js';
/** An interface for Open/Close/Destroy driven Events */
export default class Closeable extends Hideable {
    /** A series of Open/Close Related Events and Methods
        @param {EL} node Class to implement this interface (Typically 'this')
    */
    constructor(node) {
        super(node); //'closeable'
    }
    addListeners(node) {
        node.on('open', () => node.open());
        node.on('close', () => node.close());
    }
    setMethods(node) {
        /** Open this element */
        this.methods.open = () => node.chain(() => node.addClass('open'));
        /** Shows the element */
        this.methods.show = () => node.chain(() => {
            node.el.style.display = 'block';
            node.removeClass('hiding');
        });
        /** Hides this element
            @param {number} delay Millisecond delay until element is closed
            @param {boolean} preserve If true, element is not deleted
        */
        this.methods.hide = (delay = 200, preserve = true) => new Promise((resolve, reject) => {
            try {
                node.addClass('hiding');
                setTimeout(() => {
                    if (preserve) {
                        resolve(node);
                    }
                    else {
                        node.destroy().then(() => {
                            console.log('Closing "CLOSEABLE" element, resolving caller', node.caller);
                            resolve(node.caller.deactivate());
                        });
                    }
                }, delay);
            }
            catch (e) {
                reject(e);
            }
        });
        /** Close (Hide and Destroy) this element
            @param {number} delay Millisecond delay until element is closed
        */
        this.methods.close = (delay = 200) => node.hide(delay, false);
    }
}
export { Close, EL, Hideable, IFACE, Open };
